module.exports = "images/ico-instagram.svg";